
export type NullableNumber = number | null | undefined;
export type OptionalNumber = number | undefined;

export class MathHelper {

    static nullableDiv(dividend: NullableNumber, divisor: NullableNumber): OptionalNumber {
        return (dividend != null && divisor != null) ? dividend / divisor : undefined;
    }

    static safeDiv(dividend: number, divisor: number): number {
        if (divisor === 0) {
            return Number.NaN;
        } else {
            return dividend / divisor;
        }
    }

    static zeroIfNull(value: NullableNumber): number {
        return value ?? 0;
    }
}
